class InputValue {
  recordId: string
  value: string

  constructor(input?: any) {
    this.recordId = input?.recordId
    this.value = input?.value ?? null
  }
}

export default InputValue
